import React from "react";
import { IonSlides, IonSlide, IonContent, IonModal } from "@ionic/react";
// import CommonHeader from "../CommonHeader";

type GalleryProps = {
  title?: string
  isOpen: boolean,
  slideOpts?: any,
  handleSlideChange?: any,
  images?: any,
  onClose?: any,
  editImage?: any,
  setShowPreview?: any
}

const PhotoGallery = (props:GalleryProps) => {
  return (
    <IonModal isOpen={props.isOpen} onDidDismiss={()=>{props.setShowPreview(false)}}>
      <IonContent className="ion-padding">
      <IonSlides
        options={props?.slideOpts}
        pager={true}
      > 
      {
        props?.images && props?.images?.length > 0 && 
        <>
          {props?.images.map((p:any, i : any)=>(
            <IonSlide key={"preview_image-"+i}>
              <img src={p.img} alt={"Preview Image "+i} onClick={()=> {props.editImage(i)}} />
            </IonSlide>
          ))}
        </>
      }
      </IonSlides>
      </IonContent>
    </IonModal>
  )
};

export default PhotoGallery;